type StringOrNumber = string | number;
export default <T extends { [key in StringOrNumber]: StringOrNumber }, V extends StringOrNumber>(enumerable: T, value: V): (keyof T) | undefined => {
    return Object.keys(enumerable).find((key) => enumerable[key] === value);
}
